module.exports = "\n<h1 mat-dialog-title>{{data.text}}</h1>\n\n<div mat-dialog-actions>\n  <button mat-button (click)=\"onNoClick()\">Ok</button>\n\n</div>"